import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import React, { useContext, useState } from "react";
import Loader from "../components/common/loader/Loader";
import { UserContext } from "../contexts/UserContext";

export default function CreateGame(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));

  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };

  const handleOk = async () => {
    setIsLoading(true);
    for (let i = 0; i < props.IdGames.length; i++) {
      let deleteRequest = {
        IdGame: props.IdGames[i],
        IdUser: userInfo.userId,
      };
      console.log(deleteRequest);
      await axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/Game/DeleteGame",
        //url: 'https://localhost:44337/api/Game/DeleteGame',
        data: deleteRequest,
      }).then((response) => {
        if (response.data == "1") {
          alert(
            "Cannot delete the game: " + props.IdGames[i] + " with this status."
          );
        } else if (response.data == "2") {
          alert(
            "Cannot delete the game: " +
            props.IdGames[i] +
            " because has family."
          );
        } else if (response.data == "3") {
          alert(
            "Cannot delete the game: " +
            props.IdGames[i] +
            " because has periods."
          );
        } else if (response.data == "4") {
          alert(
            "Cannot delete the game: " + props.IdGames[i] + " because has bets."
          );
        } else if (response.data == "5") {
          alert(
            "Cannot delete the game: " +
            props.IdGames[i] +
            " because has graded bets."
          );
        } else if (response.data == "6") {
          alert(
            "Cannot delete the game: " +
            props.IdGames[i] +
            " because has pending bets."
          );
        }
      });
    }
    alert("Games succesfully deleted.");
    props.clearArray();
    props.searchGameValues();
    setIsLoading(false);
    handleClose();
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Delete Game
            </Typography>
          </Toolbar>
        </AppBar>

        <DialogActions>
          {isLoading ? (
            <Loader height={100} width={100}></Loader>
          ) : (
            <div>
              <Button
                color="inherit"
                startIcon={<CancelIcon />}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                startIcon={<SaveIcon />}
                variant="contained"
                color="primary"
                onClick={handleOk}
              >
                Ok
              </Button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
